<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <el-form-item class="page-panel-search-form-right-button">
        <el-button type="primary" @click="dialogVisable=true">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="bannerList" border stripe>
      <el-table-column width="50" align="center" label="序号">
        <template
          slot-scope="scope"
        >{{(scope.$index+1)+((searchModel.pageNo-1)*searchModel.pageSize)}}</template>
      </el-table-column>
      <el-table-column align="center" prop="bannerName" label="banner名称"></el-table-column>
      <el-table-column align="center" prop="bannerImg" label="图片">
        <template slot-scope="scope">
          <ul v-viewer>
            <img
              :src="scope.row.bannerImg"
              alt
              height="60px"
              onerror="this.src='/static/img/unload.gif"
            />
          </ul>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="bannerOrder" label="排序"></el-table-column>
      <el-table-column align="center" prop="bannerUrl" label="链接地址"></el-table-column>
      <el-table-column align="center" label="是否展示">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.isHide"
            @change="hideBanner(scope.row)"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click.stop="upBanner(scope.row)">编辑</el-button>
          <el-button type="text" @click.stop="delBanner(scope.row.bannerId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-panel-footer">
      <el-pagination
        :current-page.sync="searchModel.pageNo"
        @current-change="getBanners"
        :page-size="searchModel.pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="新增banner" :visible.sync="dialogVisable" width="40%">
      <el-form ref="form" label-width="90px">
        <el-form-item label="banner名称">
          <el-input v-model="bannerParam.bannerName"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action="/file/upload"
            :show-file-list="false"
            :on-success="handleSuccess"
            :headers="headers"
          >
            <img v-if="imgUrl" :src="imgUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-dialog :visible.sync="imgDialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="顺序">
          <el-input-number v-model="bannerParam.bannerOrder" label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item label="链接地址">
          <el-input v-model="bannerParam.bannerUrl"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable= false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as bannerApi from '@/api/adminApi/zh/banner';
import { localStorage } from '@/common/util/storage';
export default {
  data() {
    return {
      headers: {
        token: localStorage.get('token')
      },
      imgUrl: '',
      bannerParam: {},
      imgDialogVisible: false,
      dialogImageUrl: '',
      dialogVisable: false,
      total: 0,
      bannerList: [],
      searchModel: {
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  methods: {
    hideBanner(row) {
      bannerApi
        .hideBanner({ bannerId: row.bannerId, isHide: row.isHide })
        .then(res => {
          this.getBanners();
        });
    },
    upBanner(row) {
      this.bannerParam = JSON.parse(JSON.stringify(row));
      this.imgUrl = this.bannerParam.bannerImg;
      this.dialogVisable = true;
    },
    handleSuccess(res, file) {
      this.imgUrl = res.url;
      this.bannerParam.bannerImg = res.url;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    update() {
      if (this.bannerParam.bannerId) {
        bannerApi.upBanner(this.bannerParam).then(res => {
          this.getBanners();
          this.bannerParam = {};
          this.dialogVisable = false;
        });
      } else {
        bannerApi.addBanner(this.bannerParam).then(res => {
          this.getBanners();
          this.imgUrl = '';
          this.bannerParam = {};
          this.dialogVisable = false;
        });
      }
    },
    delBanner(bannerId) {
      this.$confirm('是否确认删除此Banner', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          bannerApi.delBanner({ bannerId: bannerId }).then(res => {
            this.getBanners();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    getBanners() {
      bannerApi.getBanners(this.searchModel).then(res => {
        this.bannerList = res.data.list;
        this.total = res.data.pageTotal;
      });
    }
  },
  created() {
    this.getBanners();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/comprehensive/banner.vue